import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';

export interface Props {
  isSmall?: boolean;
  kaleComponent?: string;
}

export const Button = styled.button<{ small?: boolean }>`
  @import './mixins.scss';
  @include button(primary);
  height: 48px;
  padding: 0 48px;

  &.small {
    height: 44px;
    font-size: 12px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 0;
  }

  i {
    padding-left: 1ch;
  }
`;

const SignUpButton = React.forwardRef<
  HTMLButtonElement,
  React.PropsWithChildren<Props>
>(({ isSmall, kaleComponent, children }, ref) => {
  const cta = 'Sign up to access Courses';
  const url = routes.signup_url({
    post_login_redirect_url: encodeURIComponent(window.location.href),
    post_signup_redirect_url: encodeURIComponent(window.location.href),
    s: 'courses',
  });
  return (
    <a
      href={url}
      {...(kaleComponent && {
        'data-kale-collection': 'Courses',
        'data-kale-component': kaleComponent,
      })}
      rel="nofollow"
    >
      <Button small={isSmall} ref={ref}>
        {children ?? cta}
        <i>
          <FontAwesomeIcon icon={faCaretRight} />
        </i>
      </Button>
    </a>
  );
});

export default SignUpButton;
